var _rect, _rect2, _rect3, _rect4, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooklet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 578,
    height: 357,
    viewBox: "0 0 578 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 568,
    height: 335,
    fill: "#F8EFE7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 578,
    y: 6,
    width: 8,
    height: 578,
    rx: 4,
    transform: "rotate(90 578 6)",
    fill: "#513A2A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 573,
    width: 20,
    height: 568,
    rx: 4,
    transform: "rotate(90 573 0)",
    fill: "url(#paint0_linear_1363_12639)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 578,
    y: 343,
    width: 8,
    height: 578,
    rx: 4,
    transform: "rotate(90 578 343)",
    fill: "#513A2A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 357,
    width: 20,
    height: 568,
    rx: 4,
    transform: "rotate(-90 5 357)",
    fill: "url(#paint1_linear_1363_12639)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1363_12639",
    x1: 573,
    y1: 272.417,
    x2: 593,
    y2: 272.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEB499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9165"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1363_12639",
    x1: 5,
    y1: 629.417,
    x2: 25,
    y2: 629.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEB499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB9165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F866C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooklet);
export default __webpack_public_path__ + "static/media/booklet.bc8e024a04c4e16724c386148e169d5d.svg";
export { ForwardRef as ReactComponent };